document.querySelectorAll('hdt-accordion details').forEach((targetDetail) => {
  targetDetail.addEventListener('click', () => {
    // Close all other details except the one clicked
    document.querySelectorAll('hdt-accordion details').forEach((detail) => {
      if (detail !== targetDetail) {
        detail.removeAttribute('open');
      }
    });
  });
});